module.exports = __webpack_public_path__ + "img/sum.a8b4f613.svg";